export default "__VITE_ASSET__$BibUKNV__"